import { render, staticRenderFns } from "./FormMember.vue?vue&type=template&id=a23b2d9c&"
import script from "./FormMember.vue?vue&type=script&lang=js&"
export * from "./FormMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports